import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { debounceTime, map } from 'rxjs/operators';
import { AutoUnsubscribe } from '../../common/decorators';
import { Subscription } from 'rxjs';
import { AnyFilterItem, FilterSettings } from './models';
import { parseChipsInputBulkDataEntry, removeInputElement, replaceSlash } from '../../common/utils';
import { ENTER } from '@angular/cdk/keycodes';
import { FilterType } from './constants';
import { IconNames, ListQueryParam, SearchCriteria } from '../../common';

@Component({
  selector: 'ui-list-filter',
  templateUrl: './list-filter.component.html',
  styleUrls: ['./list-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class ListFilterComponent {
  @Input() set filtersConfig(config: FilterSettings) {
    if (config) {
      this.settings = config;
      this.initFilters();
    }
  }

  @Input() isTimeRangeResetAvailable = false;

  @Output() filtersChange: EventEmitter<SearchCriteria> = new EventEmitter<SearchCriteria>();

  filterType = FilterType;
  filtersForm: UntypedFormGroup;
  settings: FilterSettings;
  subscriptions: Subscription[] = [];
  chipsInputControl: UntypedFormControl = new UntypedFormControl('');
  separatorKeysCodes: number[] = [ENTER];
  iconNames = IconNames;
  removeElement = removeInputElement;

  constructor(public cd: ChangeDetectorRef) {}

  addElement(
    control: UntypedFormControl | AbstractControl,
    input: HTMLInputElement,
    inputControl: UntypedFormControl,
  ): void {
    parseChipsInputBulkDataEntry(control, input, inputControl);
  }

  private initFilters(): void {
    this.filtersForm = new UntypedFormGroup({});
    this.settings.items.forEach((filter: AnyFilterItem) => {
      this.filtersForm.addControl(
        filter.name,
        new UntypedFormControl({ value: filter.initialValue, disabled: filter.disabled }, []),
      );
    });
    this.subscriptions.push(this.formChangeSubscription());
  }

  private formChangeSubscription(): Subscription {
    return this.filtersForm.valueChanges
      .pipe(
        debounceTime(500),
        map((filterList: SearchCriteria) => this.checkAndUpdateFilterList(filterList)),
      )
      .subscribe((formValue: SearchCriteria) => {
        this.filtersChange.emit(formValue);
      });
  }

  private checkAndUpdateFilterList(filterList: SearchCriteria): SearchCriteria {
    Object.keys(filterList).forEach((value: ListQueryParam) => {
      if (typeof filterList[value] === 'string') {
        filterList[value] = replaceSlash(filterList[value]);
      }
    });
    return filterList;
  }
}
